<pf-content>
    @if (containers().length) {
        <div class="bin-grid">
            @for (c of containers(); track c.container.id) {
                <pf-card [title]="binHeader" class="bin-card">
                    <ng-template #binHeader>
                        <div class="bin-header">
                            <span class="bin-header__name">{{
                                c.displayName
                            }}</span>
                            @if (c.hasItems) {
                                <span class="qty-badge"
                                    >&times;{{ c.totalQuantity }}</span
                                >
                            }
                        </div>
                    </ng-template>
                    @if (c.bundles.length) {
                        @for (bundle of c.bundles; track bundle.itemCode) {
                            <div class="bundle">
                                <div class="bundle-info">
                                    <span class="bundle-item-name">{{
                                        bundle.itemName
                                    }}</span>
                                    @if (bundle.itemCode) {
                                        <span class="bundle-item-code">{{
                                            bundle.itemCode
                                        }}</span>
                                    }
                                </div>
                                <div class="bundle-right">
                                    <span class="qty-badge"
                                        >&times;{{ bundle.totalQuantity }}</span
                                    >
                                    <pf-chip
                                        class="bundle-chip"
                                        [pfColor]="bundle.statusColor"
                                        >{{ bundle.status }}</pf-chip
                                    >
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="empty-container">No items</div>
                    }
                </pf-card>
            }
        </div>
    } @else {
        <div class="empty-state">No containers assigned</div>
    }
</pf-content>
